export default __webpack_public_path__ + "static/media/radijatoror.72c116a1.png";